package com.nonopn.skywatcher.common.login.pages

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.login.LocalLoginCaller
import com.nonopn.skywatcher.common.login.sub.CreateAccountScreen
import eu.codlab.compose.widgets.systemBackground
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteRegister : RouteParameterTo

object RouterRegister : RouterNoParameters<RouteRegister>(RouteRegister::class) {
    override fun routeFrom(parameters: RouteRegister) = "/register"

    @Composable
    override fun Show(parameters: RouteRegister) {
        RouteRegisterImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteRegister,
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(
                launchSingleTop = false,
                popUpBackTo = RouteMain
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteRegister

    override fun isMatching(route: String) = route == "/register"

    override fun navigateFrom(path: String) = RouteRegister
}

class RouteRegisterImpl : Route<RouteRegister>(
    route = "/register",
    params = RouteRegister,
) {
    @Composable
    override fun scene() {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .systemBackground()
        ) {
            CreateAccountScreen(LocalLoginCaller.current)
        }
    }
}
